export class CreateNCDModel{

    Locality: number;
    FocalPersonId:number;
    Name:string;
    Contact:string;
    DistrictId:number;
    isFP: boolean = true;
}


export class CreateFieldOfficerModel{

    Locality: number;
    FocalPersonId:number;
    Name:string;
    Contact:string;
    DistrictId:number;
    isFP: boolean = false;
}
